/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'bi/glass/app/plugins/MenuActionInterface',
	'../../nls/StringResources',
	'bi/commons/utils/LegacyUtils'
], function(MenuActionInterface, StringResources, LegacyUtils) {
	'use strict';

	class MenuItemController extends MenuActionInterface {
		/**
		 * Called when the Menu Item is selected.
		 */
		onSelectItem(context) {
			const itemSpec = context.target.plugin.itemSpec.items[context.target.specItemIndex];
			const options = itemSpec.options;
			options.launchPoint = context.target.plugin.getButtonElement();
			options.label = StringResources.get('legacyAppsSlideoutLabel');
			context.glassContext.appController.showSlideOut(options);
		}

		isItemVisible(context) {
			if (context.glassContext.legacyLaunchable) {
				for (let item in LegacyUtils.legacyApps) {
					if (LegacyUtils.canUseLegacyTool(context.glassContext, item)) {
						return true;
					}
				}
			}
			return false;
		}
	}
	return MenuItemController;
});
